import { TextDecorationType } from '@kubit/web-ui-components/text/types';
import { TextVariantType } from '../../commons/components/variants';
import { FONT_STYLE, FONT_WEIGHT } from '../../commons/foundations/typography';
export const FONT_FAMILY = {
    font_family_outfit: '"Outfit Font", sans-serif',
    font_family_digit_password_circle: '"DigitPasswordCircle", sans-serif',
    font_family_digit_password_square: '"DigitPasswordSquare", sans-serif',
};
export const getTextStyles = (FONT) => {
    return {
        [TextVariantType.FONT_HEADING_1]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_1,
            font_weight: FONT_WEIGHT.font_light,
        },
        [TextVariantType.FONT_HEADING_2]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_2,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_HEADING_3]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_3,
            font_weight: FONT_WEIGHT.font_bold,
        },
        [TextVariantType.FONT_HEADING_4]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_4,
            font_weight: FONT_WEIGHT.font_light,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_5]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_5,
            font_weight: FONT_WEIGHT.font_light,
        },
        [TextVariantType.FONT_HEADING_6]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_6,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_HEADING_7]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_7,
            font_weight: FONT_WEIGHT.font_light,
        },
        [TextVariantType.FONT_HEADING_8]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_8,
            font_weight: FONT_WEIGHT.font_bold,
        },
        [TextVariantType.FONT_HEADING_9]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_9,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_HEADING_10]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_10,
            font_weight: FONT_WEIGHT.font_bold,
        },
        [TextVariantType.FONT_HEADING_11]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_11,
            font_weight: FONT_WEIGHT.font_light,
        },
        [TextVariantType.FONT_HEADING_12]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_12,
            font_weight: FONT_WEIGHT.font_light,
        },
        [TextVariantType.FONT_HEADING_13]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_13,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_HEADING_14]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_14,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_HEADING_15]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_15,
            font_weight: FONT_WEIGHT.font_bold,
        },
        [TextVariantType.FONT_HEADING_16]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_16,
            font_weight: FONT_WEIGHT.font_bold,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_17]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_17,
            font_weight: FONT_WEIGHT.font_light,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_18]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_18,
            font_weight: FONT_WEIGHT.font_regular,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_19]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_19,
            font_weight: FONT_WEIGHT.font_bold,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_20]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_20,
            font_weight: FONT_WEIGHT.font_light,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_21]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_21,
            font_weight: FONT_WEIGHT.font_regular,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_22]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_22,
            font_weight: FONT_WEIGHT.font_bold,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_23]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_23,
            font_weight: FONT_WEIGHT.font_light,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_24]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_24,
            font_weight: FONT_WEIGHT.font_regular,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_25]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_25,
            font_weight: FONT_WEIGHT.font_bold,
        },
        [TextVariantType.FONT_HEADING_26]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_26,
            font_weight: FONT_WEIGHT.font_bold,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_27]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_27,
            font_weight: FONT_WEIGHT.font_light,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_28]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_28,
            font_weight: FONT_WEIGHT.font_regular,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_29]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_29,
            font_weight: FONT_WEIGHT.font_bold,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_30]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_30,
            font_weight: FONT_WEIGHT.font_light,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_31]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_31,
            font_weight: FONT_WEIGHT.font_regular,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_32]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_32,
            font_weight: FONT_WEIGHT.font_bold,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_33]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_33,
            font_weight: FONT_WEIGHT.font_regular,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_49]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_49,
            font_weight: FONT_WEIGHT.font_light,
        },
        [TextVariantType.FONT_HEADING_50]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_50,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_HEADING_100]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_100,
            font_weight: FONT_WEIGHT.font_bold,
        },
        [TextVariantType.FONT_HEADING_200]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_200,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_HEADING_210]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_210,
            font_weight: FONT_WEIGHT.font_regular,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_225]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_225,
            font_weight: FONT_WEIGHT.font_bold,
        },
        [TextVariantType.FONT_HEADING_230]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_230,
            font_weight: FONT_WEIGHT.font_bold,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_250]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_250,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_HEADING_260]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_260,
            font_weight: FONT_WEIGHT.font_regular,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_300]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_300,
            font_weight: FONT_WEIGHT.font_bold,
        },
        [TextVariantType.FONT_HEADING_310]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_310,
            font_weight: FONT_WEIGHT.font_bold,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_400]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_400,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_HEADING_410]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_410,
            font_weight: FONT_WEIGHT.font_regular,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_HEADING_450]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_450,
            font_weight: FONT_WEIGHT.font_bold,
        },
        [TextVariantType.FONT_HEADING_460]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_heading_460,
            font_weight: FONT_WEIGHT.font_bold,
            font_style: FONT_STYLE.font_normal,
        },
        [TextVariantType.FONT_PARAGRAPH_50]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_50,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_PARAGRAPH_60]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_60,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_PARAGRAPH_100]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_100,
            font_weight: FONT_WEIGHT.font_weight_600,
        },
        [TextVariantType.FONT_PARAGRAPH_110]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_110,
            font_weight: FONT_WEIGHT.font_weight_600,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_50]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_50,
            decoration: TextDecorationType.UNDERLINE,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_60]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_60,
            decoration: TextDecorationType.UNDERLINE,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_100]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_100,
            font_weight: FONT_WEIGHT.font_weight_600,
            decoration: TextDecorationType.UNDERLINE,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_110]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_110,
            font_weight: FONT_WEIGHT.font_weight_600,
            decoration: TextDecorationType.UNDERLINE,
        },
        [TextVariantType.FONT_PARAGRAPH_200]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_200,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_PARAGRAPH_210]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_210,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_PARAGRAPH_250]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_250,
            font_weight: FONT_WEIGHT.font_weight_600,
        },
        [TextVariantType.FONT_PARAGRAPH_260]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_260,
            font_weight: FONT_WEIGHT.font_weight_600,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_200]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_200,
            font_weight: FONT_WEIGHT.font_regular,
            decoration: TextDecorationType.UNDERLINE,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_210]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_210,
            font_weight: FONT_WEIGHT.font_regular,
            decoration: TextDecorationType.UNDERLINE,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_250]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_250,
            font_weight: FONT_WEIGHT.font_weight_600,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_260]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_260,
            font_weight: FONT_WEIGHT.font_weight_600,
            decoration: TextDecorationType.UNDERLINE,
        },
        [TextVariantType.FONT_PARAGRAPH_350]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_350,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_PARAGRAPH_360]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_360,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_PARAGRAPH_400]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_400,
            font_weight: FONT_WEIGHT.font_weight_600,
        },
        [TextVariantType.FONT_PARAGRAPH_410]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_410,
            font_weight: FONT_WEIGHT.font_weight_600,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_350]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_350,
            font_weight: FONT_WEIGHT.font_regular,
            decoration: TextDecorationType.UNDERLINE,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_360]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_360,
            font_weight: FONT_WEIGHT.font_regular,
            decoration: TextDecorationType.UNDERLINE,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_400]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_400,
            font_weight: FONT_WEIGHT.font_weight_600,
            decoration: TextDecorationType.UNDERLINE,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_410]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_410,
            font_weight: FONT_WEIGHT.font_weight_600,
            decoration: TextDecorationType.UNDERLINE,
        },
        [TextVariantType.FONT_PARAGRAPH_500]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_500,
        },
        [TextVariantType.FONT_PARAGRAPH_550]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_550,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_500]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_500,
        },
        [TextVariantType.LINK_FONT_PARAGRAPH_550]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.link_font_paragraph_550,
        },
        [TextVariantType.FONT_PARAGRAPH_650]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_650,
        },
        [TextVariantType.FONT_PARAGRAPH_700]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_paragraph_700,
        },
        // DS Only
        [TextVariantType.FONT_TITLE_50]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_title_50,
            font_weight: FONT_WEIGHT.font_weight_600,
        },
        [TextVariantType.FONT_TITLE_100]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_title_100,
            font_weight: FONT_WEIGHT.font_light,
        },
        [TextVariantType.FONT_AVATARL]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_avatarl,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_AVATARMS]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_avatarms,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_AVATARXS]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_avatarxs,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_AVATARXXS]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_avatarxxs,
            font_weight: FONT_WEIGHT.font_regular,
        },
        [TextVariantType.FONT_INPUTCURRENCY]: {
            font_family: FONT_FAMILY.font_family_outfit,
            typography: FONT.font_inputcurrency,
        },
    };
};
//# sourceMappingURL=text.js.map